import axios from "axios";

export const state = {
    optionalfees: [],
};

export const getters = {
    optionalfees: state => state.optionalfees,
};

export const mutations = {
    setOptionalFees(state, newValue) {
        state.optionalfees = newValue
    },
};

export const actions = {
    fetchOptionalFees({ commit }) {
        axios.get('/optionalfees').then(res => {
            commit('setOptionalFees', res.data.optionalfees);
        })
    },
};
